import React, { useEffect, useState } from 'react'
import DashboardTile from './DashboardTile'
import LastInspection from './LastInspection'
import dashboardQueries from '../../queries/dashboardQueries'
import { DashboardTileSkeleton, LastInspectionSkeleton } from './SkeletonLoading'

const DashboardLayout = () => {

  const [result, setResult] = useState([])
  const [actionPage, setActionPage] = useState(0)
  const [commentPage, setCommentPage] = useState(0)
  const [actionSort, setActionSort] = useState('desc')
  const [commentSort, setCommentSort] = useState('desc')
  const [loading, setLoading] = useState(true)

  const getData = dashboardQueries.useSuperAdminDashboard(
    (res) => {
      setResult(res)
      setLoading(false)
    }
  )

  useEffect(() => {
    getData.mutateAsync({
      actionPage,
      commentPage,
      size: 5,
      actionSort,
      commentSort
    })
  }, [actionPage, commentPage, actionSort, commentSort]);

  return (
    <>
      {loading ? (
        <>
          <DashboardTileSkeleton />
          <div className="grid grid-cols-6 md:grid-cols-6 lg:grid-cols-12 gap-6 mt-5">
            <div className='col-span-6 h-full'>
              <LastInspectionSkeleton />
            </div>
            <div className='col-span-6 h-full'>
              <LastInspectionSkeleton />
            </div>
          </div>
        </>
      ) : (
        <>
          <DashboardTile result={result} /> 
          <div className="grid grid-cols-6 md:grid-cols-6 lg:grid-cols-12 gap-6 mt-5">
            <div className='col-span-6 h-full'>
              <LastInspection
              result={result?.lastInspections}
              type="action"
              page={actionPage}
              setPage={setActionPage}
              sort={actionSort}
              setSort={setActionSort}
              />
            </div>
            <div className='col-span-6 h-full'>
              <LastInspection
              result={result?.lastComments}
              type="comment"
              page={commentPage}
              setPage={setCommentPage}
              sort={commentSort}
              setSort={setCommentSort}
              />
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default DashboardLayout